// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
	body {
		margin: 0 !important;
	}
}

:root {
	--ck-content-font-family: 'Lato';
}

.main-container {
	font-family: var(--ck-content-font-family);
	width: fit-content;
	margin-left: auto;
	margin-right: auto;
}

.editor-container_classic-editor .editor-container__editor {
	min-width: 795px;
	max-width: 795px;
}`, "",{"version":3,"sources":["webpack://./ts/components/DescriptionEditor.css"],"names":[],"mappings":"AAEA;CACC;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n\n@media print {\n\tbody {\n\t\tmargin: 0 !important;\n\t}\n}\n\n:root {\n\t--ck-content-font-family: 'Lato';\n}\n\n.main-container {\n\tfont-family: var(--ck-content-font-family);\n\twidth: fit-content;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n.editor-container_classic-editor .editor-container__editor {\n\tmin-width: 795px;\n\tmax-width: 795px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
